<template>
  <v-container class="fill-height content">
    <v-row class="fill-height" align="center">
      <v-col>
        <div class="mb-10">
          <skr-heading level="1" semantic>{{ $t('signup.flows.eidplus.password.title') }}</skr-heading>
          <skr-heading level="2">{{ $t('signup.flows.eidplus.password.text', { n: 10 }) }}</skr-heading>
        </div>
        <password-input
          v-model="password"
          :label="$t('global.password')"
          :token="token"
          @validate="isPasswordValid => (isValid = isPasswordValid)"
        />
        <skr-button size="xl" @click="resetPassword">{{ $t('signup.flows.eidplus.password.cta') }}</skr-button>
      </v-col>
      <v-col v-if="$vuetify.display.mdAndUp">
        <responsive-image source="set-password" :width="447" :height="352" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import SkrButton from '@/components/button/SkrButton.vue'
import PasswordInput from '@/components/PasswordInput.vue'
import ResponsiveImage from '@/components/ResponsiveImage.vue'
import SkrHeading from '@/components/SkrHeading.vue'

export default defineComponent({
  components: {
    SkrHeading,
    SkrButton,
    PasswordInput,
    ResponsiveImage,
  },
  setup() {
    definePageMeta({
      layout: 'unauthenticated',
      accessControl: {
        roles: ['unauthenticated'],
      },
    })

    const widgetStore = useWidgetStore()

    const { t } = useI18n()

    const password = ref('')
    const token = ref<string | null>(null)
    const isValid = ref(false)

    const { userRepository } = useApi()

    const noToken = () => {
      // show general error snackbar
      void widgetStore.createSnackbar({
        message: t('global.general_error'),
      })
      // send user to login
      void navigateTo({ name: 'login' })
    }

    const resetPassword = async () => {
      const resetToken = token.value || ''
      if (!resetToken) return noToken()
      try {
        await userRepository.resetPassword(resetToken, password.value)
        localStorage.removeItem('reset-token')
        widgetStore.createSnackbar({
          message: t('signup.flows.eidplus.complete.snackbar.text'),
        })
        await navigateTo({ name: 'login' })
      } catch {
        localStorage.removeItem('reset-token')
        await navigateTo({ name: 'password-reset-confirm', params: { s: resetToken } })
      }
    }

    onBeforeMount(() => {
      const storedToken = localStorage.getItem('reset-token')
      if (storedToken) {
        token.value = storedToken
      } else {
        noToken()
      }
    })

    return {
      password,
      isValid,
      resetPassword,
      token,
    }
  },
  head() {
    return {
      title: 'Sign Up New EID+',
    }
  },
})
</script>
